import { useDrawer } from 'src/hooks/useDrawer';
import classNames from 'classnames';
import { SearchMobile } from 'src/svg/Vip';
import { useModalContext } from 'src/hooks/useModalContext';
import { SignUpIcon } from 'src/svg/SignUpIcon';
import { useApiContext } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';

import { WalletIcon } from 'src/svg/WalletIcon';
import { GamesIcon } from 'src/svg/GamesIcon';
import { useNavigate } from 'react-router';
import { useRoute } from 'src/router/hooks/useRoute';
import './styles.css';
import { Button } from 'src/components/Buttons/Button';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';

export const Navbar = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useApiContext();
  const { openModal } = useModalContext();
  const { isLeftDrawerOpen } = useDrawer();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();
  const { startRegistration } = useAuthFlow();

  return (
    <div className={classNames('z-20', isLeftDrawerOpen ? 'blured' : '')}>
      <div className="navbar flex justify-around items-end">
        <button
          className=" flex justify-center flex-col items-center w-[109px] h-10"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            navigate(ROUTE.GAMES.get());
          }}>
          <GamesIcon />
          <span className="text-n_menu_text text-xs font-medium">{t('menuItem.games')}</span>
        </button>
        <div
          className="flex justify-end flex-col items-center w-[109px] h-10 relative"
          onClick={() => {
            if (!isAuthenticated) {
              startRegistration({
                onSuccess: () => openModal('DEPOSIT', { replace: true }),
                defaultFlow: false
              });
              return;
            }
            openModal('DEPOSIT');
          }}>
          <Button
            mode="button-deposit"
            className="w-10 h-10 absolute navbar-button bottom-[19.5px] my-auto">
            {isAuthenticated ? <WalletIcon /> : <SignUpIcon />}
          </Button>
          <span className="text-n_menu_text text-xs font-medium first-letter:uppercase">
            {isAuthenticated ? t('general.deposit') : t('general.signUp')}
          </span>
        </div>
        <button
          className=" flex justify-center flex-col items-center w-[109px] h-10"
          onClick={() => openModal('SEARCH')}>
          <SearchMobile className="[&_path]:stroke-n_menu_text" />
          <span className="text-n_menu_text text-xs font-medium">{t('general.search')}</span>
        </button>
      </div>
    </div>
  );
};
